module.exports = __webpack_public_path__ + "media/images/common/ui/btn_chariloto_select-10998055aec81aec579669dbbb3cbddc.png";